module.exports = __webpack_public_path__ + "static/media/ste_2009_avezzano_3.1203eb01.jpg";